import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaItemComponent } from './sta-item/sta-item.component';
import { SearchPanelComponent } from './search-panel/search-panel.component';
import { SearchCategoryPanelComponent } from './search-panel/search-category-panel.component';
import { SearchRepairItemPanelComponent } from './search-panel/search-repair-item-panel.component';
import { MapComponent } from './map/map.component';
import { StaListComponent } from './sta-list/sta-list.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { DirectChangeComponent } from './direct-change/direct-change.component';
import { StaItemDetailComponent } from './sta-item-detail/sta-item-detail.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
  declarations: [
    StaItemComponent,
    SearchCategoryPanelComponent,
    SearchRepairItemPanelComponent,
    MapComponent,
    StaListComponent,
    DirectChangeComponent,
    StaItemDetailComponent,
    SearchResultComponent,
    HeaderComponent,
  ],
  imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, AgmCoreModule],
  exports: [
    StaItemComponent,
    SearchCategoryPanelComponent,
    SearchRepairItemPanelComponent,
    MapComponent,
    StaListComponent,
    DirectChangeComponent,
    StaItemDetailComponent,
    SearchResultComponent,
    HeaderComponent,
  ],
})
export class ComponentsModule {}
